import {isIOS, isAndroid, OPERATION_LIMIT} from './config'
import {getABNames, triggerAction} from "./bridge"
import {logRed} from "./log";
import {Toast} from "antd-mobile";

const inApp = isIOS || isAndroid

const isDevelopment = process.env.NODE_ENV === 'development'

interface queryObj {
  avatarURL?: string,
  isSee?: number
}

function parseQuery(): queryObj {
  let qs = window.location.search
  if (qs.length <= 1) {
    return {}
  }
  qs = qs.slice(1)
  const split = qs.split('&')
  const result = {}

  split.forEach((s) => {
    const [key, value] = s.split('=')
    if (key) {
      result[key] = value && decodeURIComponent(value)
    }
  })
  return result
}

export function getAvatar(): string {
  if (!inApp) {
    return 'http://cloud.staging1.p1staff.com/v1//images/eyJpZCI6IjJHQlFPWEhSQlA2R0ZKT1ZXWE5KT05UU1dDRUNENSIsInciOjk4NCwiaCI6OTYxLCJkIjowLCJtdCI6ImltYWdlL2pwZWciLCJkaCI6MjkzODc1NzQzMzY0Nzk4Mjk1M30.jpg?format=640x640'
  }

  let avatar = parseQuery().avatarURL
  if (avatar) {
    const split = avatar.split('?')
    avatar = `${split[0]}?format=480x480`
  } else {
    avatar = ''
  }
  return avatar
}

// 保留两位有效数字（一位数补零）
export function numToFixed2(num: number): string {
  return num < 10 ? `0${num}` : String(num)
}

// 格式化列表时间
export function getListTime(timeStr: string): string {
  const date = new Date(Number(timeStr) / 1000000)
  const cDay = ['日', '一', '二', '三', '四', '五', '六']
  return `星期${cDay[date.getDay()]} ${numToFixed2(date.getHours())}:${numToFixed2(date.getMinutes())}`
}

// 获取日报图片上的时间
export function getImgTime(timeStr: string): string {
  const date = new Date(Number(timeStr) / 1000000)
  return `${date.getFullYear()}/${numToFixed2(date.getMonth() + 1)}/${numToFixed2(date.getDate())}`
}

// 获取ListView行数据
export function genRowData(refreshIndex = 0, pIndex = 0, limit = OPERATION_LIMIT) {
  const dataArr = []
  for (let i = 0; i < limit; i++) {
    dataArr.push(`row - ${refreshIndex} - ${(pIndex * limit) + i}`)
  }
  return dataArr
}

// 跳转话题
export function jumpToTopicAggregationActLocal(topicId = '') {
  if (isAndroid) {
    triggerAction({
      actionType: 'jumpToTopicAggregationAct',
      restParams: {
        id: topicId,
      }
    })
  } else if (isIOS) {
    triggerAction({
      actionType: 'jumpToTopic',
      restParams: {
        topicID: topicId,
        from: ''
      }
    })
  }
}

// 判断当前用户是否在实验组内
export async function checkInAB(ABKey: string) {
  if (isDevelopment) {
    return false
  }
  const ABNames = await getABNames()
  return ABNames.includes(ABKey) || process.env.NODE_ENV === 'development'
}

// 跳转不同类型话题
export const jumpTopic = (
  id: string,
  from: string,
  landingPage: string,
  topicType: "topic" | "vote" | "anonymous" | "link" | "qa",
  name: string
  // eslint-disable-next-line max-params
) => {
  if (isIOS) {
    triggerAction({
      actionType: "jumpToTopic",
      restParams: {
        topicID: id,
        from: from,
      },
    })
  } else if (isAndroid) {
    if (topicType === "link") {
      triggerAction({
        actionType: "openWebview",
        restParams: {
          url: `tantanapp://topic_webview?title=${name}&url=${landingPage}`,
          title: name,
        },
      })
    } else if (topicType === "vote") {
      triggerAction({
        actionType: "jumpToTopicVoteAggregationAct",
        restParams: {
          id: id,
          topicOwnerId: "-10010",
          momentId: "-1",
        },
      })
    } else if (topicType === "qa") {
      triggerAction({
        actionType: "jumpToQATopicAggregationAct",
        restParams: {
          topicId: id,
        },
      })
    } else {
      triggerAction({
        actionType: "jumpToTopicAggregationAct",
        restParams: {
          id: id,
        },
      })
    }
  } else {
    Toast.info("请在手机端打开该页面~", 1)
  }
}

// 过滤emoji表情
export const filteremoji = (emojireg: string): string => {
  const ranges = [
    '\ud83c[\udf00-\udfff]',
    '\ud83d[\udc00-\ude4f]',
    '\ud83d[\ude80-\udeff]'
  ]
  return emojireg.replace(new RegExp(ranges.join('|'), 'g'), '')
}
